module.exports = __webpack_public_path__ + "img/thumbnail_Cougar_j_normal.c4f8cdce.png";